import { ChangeEvent, useState } from 'react';

import cardValidator from 'card-validator';

export type ValidationCreditCardType =
  | 'visa'
  | 'mastercard'
  | 'american-express'
  | 'mada';

export const useCreditCardValidation = () => {
  const [creditCardNumber, setCreditCardNumber] = useState('');
  const [creditCardCvv, setCreditCardCvv] = useState('');

  const [isCreditCardNumberValid, setIsCreditCardNumberValid] = useState(false);
  const [isCreditCardCvvValid, setIsCreditCardCvvValid] = useState(true);

  const [creditCardType, setCreditCardType] = useState<ValidationCreditCardType | null>(
    null
  );
  const [creditCardCvvLength, setCreditCardCvvLength] = useState<number | null>(null);

  const handleCreditCardNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\s/g, '');
    setCreditCardNumber(value);
    const numberValidation = cardValidator.number(value);

    if (
      numberValidation.isValid &&
      ((['visa', 'mastercard'].includes(numberValidation.card?.type) &&
        value.length === 16) ||
        (numberValidation.card?.type === 'american-express' && value.length === 15))
    ) {
      setIsCreditCardNumberValid(numberValidation.isValid);
      setCreditCardType(numberValidation.card?.type as ValidationCreditCardType);
      setCreditCardCvvLength(numberValidation.card?.code?.size);

      const cvvValidation = cardValidator.cvv(
        creditCardCvv,
        numberValidation.card?.code?.size
      );
      setIsCreditCardCvvValid(cvvValidation.isValid);
    } else if (numberValidation.isValid) {
      setIsCreditCardNumberValid(numberValidation.isValid);
      setCreditCardType(null);
      setCreditCardCvvLength(numberValidation.card?.code?.size);

      const cvvValidation = cardValidator.cvv(
        creditCardCvv,
        numberValidation.card?.code?.size
      );
      setIsCreditCardCvvValid(cvvValidation.isValid);
    } else if (numberValidation.isPotentiallyValid) {
      setIsCreditCardNumberValid(false);
      setCreditCardType(numberValidation.card?.type as ValidationCreditCardType);
      setCreditCardCvvLength(numberValidation.card?.code?.size);

      const cvvValidation = cardValidator.cvv(
        creditCardCvv,
        numberValidation.card?.code?.size
      );
      setIsCreditCardCvvValid(cvvValidation.isValid);
    } else {
      setIsCreditCardNumberValid(false);
      setCreditCardType(null);
      setCreditCardCvvLength(null);
    }
  };

  const handleCreditCardCvvChange = (e: ChangeEvent<HTMLInputElement>) => {
    const cvvValidation = cardValidator.cvv(e.target.value, creditCardCvvLength);
    setCreditCardCvv(e.target.value);
    setIsCreditCardCvvValid(cvvValidation.isValid);
  };

  return {
    creditCardNumber,
    creditCardCvv,
    isCreditCardNumberValid,
    isCreditCardCvvValid,
    creditCardType,
    handleCreditCardNumberChange,
    handleCreditCardCvvChange,
  };
};
